/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionaryType } from 'app/shared/model/clinical-dictionary-type.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IUserAttribute {
  id?: string;
  userId?: string;
  tenantId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  attributeType?: IClinicalDictionaryType | null;
  attributeEntry?: IClinicalDictionary | null;
  tenantType?: IClinicalDictionary | null;
  userType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IUserAttribute> = {
  active: false,
};
